import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Startpage from './Startpage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import NewsPage from './pages/NewsPage';
import Article from './pages/Article';
import Admin from './pages/Admin';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Startpage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:id" element={<Article />} />
          <Route path="/admin" element={<Admin/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
